<section class="page-container">
  <div>
    <h1>Welcome: {{getUserFullName()}}</h1>
  </div>
  <div class="dash-inner-wrapper">
    <mat-card class="mat-elevation-z7 no-outline" [ngClass]="{'disabled': !widgets.enabled}"
      (click)='goTo(widgets)' *ngFor="let widgets of dashboardWidgets">
      <div>
        <mat-icon>{{ widgets.icon }}</mat-icon>
        <h1>{{ widgets.label | titlecase }}</h1>
      </div>
      <mat-card-content>
        <p>{{ widgets.description }}</p>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="brand"></div>
</section>
